<!-- A link that has an arrow or external icon after it. Used to show bigger and noticeable links. -->
<template>
  <RouterLink v-if="isInternalRouteLink && to" :to="to" class="link-with-icon">
    <span><slot></slot></span>
    <i class="icon-chevron-right" aria-hidden="true"></i>
  </RouterLink>
  <a
    v-else-if="isExternalLink && to"
    :href="to as string"
    class="link-with-icon"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Ulkoinen linkki. Siirtyy toiseen verkkopalveluun ja avautuu uuteen selainikkunaan"
  >
    <span><slot></slot></span>
    <i class="icon-linkexternal" aria-hidden="true"></i>
  </a>
  <a v-else class="link-with-icon" @click="emit('click', $event)" :href="to as string">
    <span><slot></slot></span>
    <i class="icon-chevron-right" aria-hidden="true"></i>
  </a>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from 'vue-router';

const emit = defineEmits(['click']);

const { to } = defineProps<{
  to?: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric;
}>();

const parsedHost = computed(() => {
  return typeof to === 'string' ? URL.parse(to)?.host : '';
});

const isInternalRouteLink = computed(() => {
  return typeof to === 'object' || (typeof to === 'string' && !to?.startsWith('http'));
});

const isExternalLink = computed(() => {
  return !isInternalRouteLink.value && !(parsedHost.value === 'op-koti.fi');
});
</script>
